import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"; // 默认主题

import "leaflet/dist/leaflet.css";
// import '@supermap/iclient-leaflet'
import "leaflet/dist/leaflet";

import iView from "iview";
import axios from "./http.js";
// import axios from 'axios';
import store from "./store/store";
import userStore from "./store/store";
import qs from "qs";
//时间转换字符
import Time from "../static/js/time.js";
import FileSaver from "file-saver";
import XLSX from "xlsx";
// import * as echarts from "echarts"; //引入echarts
import * as echarts from "echarts";
import $ from "jquery";

import VueI18n from "vue-i18n";
import { messages } from "./components/common/i18n";

import MyUtil from "../static/js/MyUtil";

import "../static/css/ol.css"; // 引入百度地图css

import "../static/iconfont/iconfont.css";
import "../static/iconfont2/iconfont.css";
import "../static/iconfontDQ/iconfont.css";
import "./assets/css/screen.css";
import "./assets/css/index.less";
import "../static/css/icon.css";
import "babel-polyfill";
import "../static/css/scrollbar.css"; //引入滚动条样式
import "./assets/css/common.css";
import App from "./App.vue";
import router from "./router";
import BaiduMap from "vue-baidu-map";
import "swiper/dist/css/swiper.css";
import VueAwesomeSwiper from "vue-awesome-swiper";

import HPagination from "./Hcomponents/HPagination/index.vue";
import HTable from "./Hcomponents/Htable/index.vue";
import DictTag from "./Hcomponents/DictTag/index";
import HSearchModule from "./Hcomponents/HsearchModel/index";
import HEcharts from "./Hcomponents/HEcharts/index.vue";
// import HRtspPlayer from './Hcomponents/HRtspPlayer/index.vue'
// 注册全局组件
Vue.component("Pagination", HPagination);
Vue.component("HTable", HTable);
Vue.component("DictTag", DictTag);
Vue.component("HSearchModule", HSearchModule);
Vue.component("HEcharts", HEcharts);
// Vue.component('HRtspPlayer', HRtspPlayer);

Vue.use(VueAwesomeSwiper);
//import localAPI from '../static/js/localAPI'
import less from "less";
Vue.use(less);
import moment from "moment";
Vue.prototype.$moment = moment;

Vue.use(BaiduMap, {
    ak: "oLf54HhrIy1vAVKRrukSBiFPEHQPOkrA",
});

Vue.prototype.ATDemo = window.ATDemo;
Vue.prototype.AT = window.AT;
Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.prototype.$qs = qs;

Vue.use(ElementUI, {
    size: "small",
});
Vue.prototype.$axios = axios;
Vue.prototype.$Time = Time;
Vue.prototype.MyUtil = MyUtil;
axios.defaults.withCredentials = true;

Vue.prototype.$ajax = axios;
Vue.prototype.$echarts = echarts; //引入组件
Vue.prototype.$FileSaver = FileSaver;
Vue.prototype.$XLSX = XLSX;
//Vue.prototype.localAPI=localAPI;

Vue.prototype.$Hls = window.Hls;

const i18n = new VueI18n({
    locale: "zh",
    messages,
});

//======================

//=====================

//使用钩子函数对路由进行权限跳转
Vue.use(router);
Vue.use(iView);
router.beforeEach((to, from, next) => {
    //    store.state.currmenu=to.path
    const role = sessionStorage.getItem("dytoken");
    if (!role && to.path !== "/login") {
        next("/login");
    }
    // else if (to.meta.permission) {
    //     // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
    //     role === 'admin' ? next() : next('/403');
    // }
    else {
        // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
        if (navigator.userAgent.indexOf("MSIE") > -1 && to.path === "/editor") {
            Vue.prototype.$alert(
                "vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看",
                "浏览器不兼容通知",
                {
                    confirmButtonText: "确定",
                }
            );
        } else {
            next();
        }
    }
});

router.afterEach((to, from) => {
    if (to.path !== "/homepage"&&to.path !== "/login") {
        store.dispatch("getAlarmNum");
        store.dispatch("getBusinessNum");
    }
});

//localAPI.init(axios,store)

new Vue({
    router,
    store,
    userStore,
    i18n,
    render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js